import React, { createContext, ReactNode, useReducer } from 'react';
import {
  SET_API_ERROR,
  SUBMIT_PLAN,
  SET_SUBMIT_PLAN_ACTIVE,
  DISCARD_FORM,
  HAS_FORM_BEEN_MODIFIED,
  SET_REQ_QUEST,
  SHOW_REQ_SWITCH,
  SHOW_READ_ONLY_FORM_SWITCH,
  SHOW_STICKIES,
  SET_PARSING_FORM_ERROR,
  SET_FAJITA_SELECTED,
  SHOW_STICKIES_CONFIRM_DIALOG,
} from './constants';

type FajitaContextProviderProps = {
  children: ReactNode;
};

type FajitaContext = {
  apiError: string | null;
  submitPlan: mumms.SubmitPayload;
  submitPlanActive: boolean;
  formModified: boolean;
  discardForm: boolean;
  reqQuest: boolean;
  reqSwitch: boolean;
  readOnlyFormSwitch: boolean;
  parsingFormError: boolean;
  showStickies: string | null;
  showStickiesConfirmDialog: boolean;
  fajitaSelected: boolean;
  dispatch?: any;
};

type FajitaContextState = {
  apiError: string | null;
  submitPlan: mumms.SubmitPayload;
  submitPlanActive: boolean;
  formModified: boolean;
  discardForm: boolean;
  reqQuest: boolean;
  showStickies: string | null;
  showStickiesConfirmDialog: boolean;
  parsingFormError: boolean;
  reqSwitch: boolean;
  readOnlyFormSwitch: boolean;
  fajitaSelected: boolean;
};
const initialState = {
  apiError: null,
  submitPlan: null,
  submitPlanActive: false,
  formModified: false,
  discardForm: false,
  reqQuest: false,
  showStickies: null,
  showStickiesConfirmDialog: false,
  reqSwitch: false,
  readOnlyFormSwitch: false,
  parsingFormError: false,
  fajitaSelected: false,
};

const initFajitaContext = {
  apiError: null,
  submitPlan: null,
  submitPlanActive: false,
  formModified: false,
  discardForm: false,
  reqQuest: false,
  showStickies: null,
  showStickiesConfirmDialog: false,
  reqSwitch: false,
  readOnlyFormSwitch: false,
  parsingFormError: false,
  fajitaSelected: false,
};

export const FajitaContextReducer = (
  state: FajitaContextState,
  action: { type: string; payload: any },
) => {
  let newState = { ...state };
  switch (action.type) {
    // @note NOT USED YET
    case SET_API_ERROR:
      newState.apiError = action.payload;
      break;
    // triggers the onSubmit function
    case SUBMIT_PLAN:
      newState.submitPlan = action.payload;
      break;
    // submit plan disabled until click on change happens
    case SET_SUBMIT_PLAN_ACTIVE:
      newState.submitPlanActive = action.payload;
      break;
    case DISCARD_FORM:
      newState.discardForm = action.payload;
      break;
    // controls auto saving and upon exiting the form should the action be save WIP or exit
    case HAS_FORM_BEEN_MODIFIED:
      newState.formModified = action.payload;
      break;
    case SET_REQ_QUEST:
      newState.reqQuest = action.payload;
      break;
    case SHOW_REQ_SWITCH:
      newState.reqSwitch = action.payload;
      break;
    case SHOW_READ_ONLY_FORM_SWITCH:
      newState.readOnlyFormSwitch = action.payload;
      break;
    case SHOW_STICKIES:
      newState.showStickies = action.payload;
      break;
    case SET_PARSING_FORM_ERROR:
      newState.parsingFormError = action.payload;
      break;
    case SET_FAJITA_SELECTED:
      newState.fajitaSelected = action.payload;
      break;
    case SHOW_STICKIES_CONFIRM_DIALOG:
      newState.showStickiesConfirmDialog = action.payload;
      break;
    default:
      newState = state;
      break;
  }
  return newState;
};

export const FajitaContext = createContext<FajitaContext>(
  initFajitaContext as FajitaContext,
);
export const FajitaContextProvider = ({
  children,
}: FajitaContextProviderProps) => {
  const [
    {
      apiError,
      submitPlan,
      submitPlanActive,
      formModified,
      discardForm,
      reqQuest,
      reqSwitch,
      readOnlyFormSwitch,
      showStickies,
      showStickiesConfirmDialog,
      parsingFormError,
      fajitaSelected,
    },
    dispatch,
  ] = useReducer(FajitaContextReducer, initialState);

  return (
    <FajitaContext.Provider
      value={{
        apiError,
        submitPlan,
        submitPlanActive,
        discardForm,
        formModified,
        reqQuest,
        reqSwitch,
        readOnlyFormSwitch,
        showStickies,
        showStickiesConfirmDialog,
        parsingFormError,
        fajitaSelected,
        dispatch,
      }}
    >
      {children}
    </FajitaContext.Provider>
  );
};

export default FajitaContextProvider;
